export enum FileMarketingType {
    POST = 'POST',
    APRESENTACAO = 'APRESENTACAO',
    FLY = 'FLY',
    LOGO = 'LOGO',
    TUTORIAL = 'TUTORIAL',
    IMAGEM = 'IMAGEM',
    VIDEO = 'VIDEO'
}